import { render, staticRenderFns } from "./HeaderBacklogComponent.vue?vue&type=template&id=7bab1284"
import script from "./HeaderBacklogComponent.vue?vue&type=script&lang=js"
export * from "./HeaderBacklogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports